export function getAutoSaveRecentKeyword() {
  const autoSaveRecentKeyword = window.localStorage.getItem(
    LOCAL_STORAGE_KEY_AUTO_SAVE_RECENT_SEARCH_KEYWORD
  );
  return !autoSaveRecentKeyword || autoSaveRecentKeyword === 'true';
}

export function setAutoSaveRecentKeyword(autoSave: boolean) {
  window.localStorage.setItem(
    LOCAL_STORAGE_KEY_AUTO_SAVE_RECENT_SEARCH_KEYWORD,
    String(autoSave)
  );
}

/** 최근 검색어 자동 저장 기능 끄기 여부 값입니다. */
const LOCAL_STORAGE_KEY_AUTO_SAVE_RECENT_SEARCH_KEYWORD =
  'auto_save_recent_search_keyword';
